<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>{{ mode == MODE_APPROVE ? '欠損最終承認' : '欠損予定一覧' }}</h1>

<!-- 検索条件コンポーネント -->
<form [formGroup]="searchCndtFormGroup" *ngIf="codeConversionMstMap?.size > 0 && cmpnyAreaList && cndtAuthorityList" (ngSubmit)="search()">
    <app-sgke400d-condition [mode]=" mode"
        [codeConversionMstMap]="codeConversionMstMap" [cmpnyAreaList]="cmpnyAreaList" [cmpnyAreaInit]="cmpnyAreaInit"
        [cndtAuthorityList]="cndtAuthorityList" (onClickClearEmitter)="clear()"></app-sgke400d-condition>
</form>

<app-sgke400d-result *ngIf="searchresultList.length > 0" [mode]="mode" [searchresultList]="searchresultList"
    [lossReasonList]="lossReasonList" (onDblClickRowEvent)="navigateBill($event)"
    (onClickOutputEvent)="download($event)" (onClickRegistrationEvent)="register($event)"
    (onClickApprovalEvent)="approve($event)"></app-sgke400d-result>